import React, { useState, useEffect } from 'react';
import Chart from '../../../../Assets/Images/gap-analysis-chart.png';
import Likert from '../../../Charts/Likert/Likert';
import HeaderPreview from '../../../GeneratePdf/HeaderPreview';
import FooterPreview from '../../../GeneratePdf/FooterPreview';

const AlignmentFlowFirst = ({ apiData, pageNumber }) => {

  const [snapshotResult, setSnapshotResults] = useState([]);
  const [starterLabel, setStarterLabel] = useState([]);
  const [variablsMapArray, setVariableMapArray] = useState();
  // Leadership chart data
  const [leadershipResult, setLeadershipResult] = useState([]);
  const [leadershipLabel, setLeadershipLabel] = useState([]);
  const [percentages, setPercentages] = useState({})

  useEffect(() => {
    // console.log(snapshotResult, starterLabel, "testttttttttt")
    // console.log(leadershipResult, leadershipLabel, "testttttttttt")
  }, [snapshotResult, leadershipResult])

  const variableMap = apiData?.variables?.reduce((acc, el) => {
    acc[el.variable] = el.score;
    return acc;
  }, {});

  useEffect(() => {
    if (variableMap) {
      setVariableMapArray(variableMap);
    }
  }, [apiData]);

  useEffect(() => {
    if (variablsMapArray) {
      // --- HEART/SOUL/MIND/STRENGTH CALCULATIONS (WHO YOU ARE) ---
      const heart_r1_m = variablsMapArray["heart_round1_m"] || 0;
      const soul_r1_m = variablsMapArray["soul_round1_m"] || 0;
      const mind_r1_m = variablsMapArray["mind_round1_m"] || 0;
      const strength_r1_m = variablsMapArray["str_round1_m"] || 0;

      const heart_r2_m = variablsMapArray["heart_round2_m"] || 0;
      const soul_r2_m = variablsMapArray["soul_round2_m"] || 0;
      const mind_r2_m = variablsMapArray["mind_round2_m"] || 0;
      const strength_r2_m = variablsMapArray["str_round2_m"] || 0;

      const heart_r1_l = variablsMapArray["heart_round1_l"] || 0;
      const soul_r1_l = variablsMapArray["soul_round1_l"] || 0;
      const mind_r1_l = variablsMapArray["mind_round1_l"] || 0;
      const strength_r1_l = variablsMapArray["str_round1_l"] || 0;

      const heart_r2_l = variablsMapArray["heart_round2_l"] || 0;
      const soul_r2_l = variablsMapArray["soul_round2_l"] || 0;
      const mind_r2_l = variablsMapArray["mind_round2_l"] || 0;
      const strength_r2_l = variablsMapArray["str_round2_l"] || 0;

      // Calculate highest scores for each quadrant
      const heart_highest = Math.max(heart_r1_m, heart_r2_m, heart_r1_l, heart_r2_l);
      const mind_highest = Math.max(mind_r1_m, mind_r2_m, mind_r1_l, mind_r2_l);
      const soul_highest = Math.max(soul_r1_m, soul_r2_m, soul_r1_l, soul_r2_l);
      const strength_highest = Math.max(strength_r1_m, strength_r2_m, strength_r1_l, strength_r2_l);

      // Calculate most, second most, least, second least scores
      let most_score = Math.max(heart_r1_m, soul_r1_m, mind_r1_m, strength_r1_m);
      let second_most_score = Math.max(heart_r2_m, soul_r2_m, mind_r2_m, strength_r2_m) / 2;
      let least_score = Math.max(heart_r1_l, soul_r1_l, mind_r1_l, strength_r1_l);
      let second_least_score = Math.max(heart_r2_l, soul_r2_l, mind_r2_l, strength_r2_l) / 2;

      if (least_score >= second_least_score) {
        least_score = (second_least_score - 1);
      }

      const total = most_score + second_most_score + least_score + second_least_score;

      const most_per = (most_score / total) * 100;
      const second_most_per = (second_most_score / total) * 100;
      const least_per = (least_score / total) * 100;
      const second_least_per = (second_least_score / total) * 100;

      const labels_arr = ["heart", "soul", "mind", "strength"];

      const mostValues = [heart_r1_m, soul_r1_m, mind_r1_m, strength_r1_m];
      const secondMostValues = [heart_r2_m, soul_r2_m, mind_r2_m, strength_r2_m];
      const leastValues = [heart_r1_l, soul_r1_l, mind_r1_l, strength_r1_l];
      const secondLeastValues = [heart_r2_l, soul_r2_l, mind_r2_l, strength_r2_l];

      const most_score_label = Math.max(...mostValues);
      const second_most_score_label = Math.max(...secondMostValues);
      const least_score_label = Math.max(...leastValues);
      const second_least_score_label = Math.max(...secondLeastValues);

      const getLabel = (values, maxValue) => labels_arr[values.indexOf(maxValue)];

      const most_label = getLabel(mostValues, most_score_label);
      const second_most_label = getLabel(secondMostValues, second_most_score_label);
      const least_label = getLabel(leastValues, least_score_label);
      const second_least_label = getLabel(secondLeastValues, second_least_score_label);

      const getPercentageOrder = (label) => {
        if (label === most_label?.toLowerCase()) return most_per;
        if (label === second_most_label?.toLowerCase()) return second_most_per;
        if (label === least_label?.toLowerCase()) return least_per;
        if (label === second_least_label?.toLowerCase()) return second_least_per;
        return 0;
      };

      // --- COLLABORATIVE/VISIONARY/PERFORMANCE/STRATEGIC CALCULATIONS (HOW YOU LEAD) ---
      const performance_r1_m = variablsMapArray["per_round1_m"] || 0;
      const strategic_r1_m = variablsMapArray["strat_round1_m"] || 0;
      const visionary_r1_m = variablsMapArray["vis_round1_m"] || 0;
      const collaborative_r1_m = variablsMapArray["col_round1_m"] || 0;

      const performance_r2_m = variablsMapArray["per_round2_m"] || 0;
      const strategic_r2_m = variablsMapArray["strat_round2_m"] || 0;
      const visionary_r2_m = variablsMapArray["vis_round2_m"] || 0;
      const collaborative_r2_m = variablsMapArray["col_round2_m"] || 0;

      const performance_r1_l = variablsMapArray["per_round1_l"] || 0;
      const strategic_r1_l = variablsMapArray["strat_round1_l"] || 0;
      const visionary_r1_l = variablsMapArray["vis_round1_l"] || 0;
      const collaborative_r1_l = variablsMapArray["col_round1_l"] || 0;

      const performance_r2_l = variablsMapArray["per_round2_l"] || 0;
      const strategic_r2_l = variablsMapArray["strat_round2_l"] || 0;
      const visionary_r2_l = variablsMapArray["vis_round2_l"] || 0;
      const collaborative_r2_l = variablsMapArray["col_round2_l"] || 0;

      // Calculate most, second most, least, second least scores for leadership
      let leadership_most_score = Math.max(performance_r1_m, strategic_r1_m, visionary_r1_m, collaborative_r1_m);
      let leadership_second_most_score = Math.max(performance_r2_m, strategic_r2_m, visionary_r2_m, collaborative_r2_m) / 2;
      let leadership_least_score = Math.max(performance_r1_l, strategic_r1_l, visionary_r1_l, collaborative_r1_l);
      let leadership_second_least_score = Math.max(performance_r2_l, strategic_r2_l, visionary_r2_l, collaborative_r2_l) / 2;

      if (leadership_least_score >= leadership_second_least_score) {
        leadership_least_score = leadership_second_least_score - 1;
      }

      const leadership_total = leadership_most_score + leadership_second_most_score + leadership_least_score + leadership_second_least_score;

      const leadership_most_per = (leadership_most_score / leadership_total) * 100;
      const leadership_second_most_per = (leadership_second_most_score / leadership_total) * 100;
      const leadership_least_per = (leadership_least_score / leadership_total) * 100;
      const leadership_second_least_per = (leadership_second_least_score / leadership_total) * 100;

      const leadership_labels_arr = ["performance", "strategic", "visionary", "collaborative"];

      const leadership_mostValues = [performance_r1_m, strategic_r1_m, visionary_r1_m, collaborative_r1_m];
      const leadership_secondMostValues = [performance_r2_m, strategic_r2_m, visionary_r2_m, collaborative_r2_m];
      const leadership_leastValues = [performance_r1_l, strategic_r1_l, visionary_r1_l, collaborative_r1_l];
      const leadership_secondLeastValues = [performance_r2_l, strategic_r2_l, visionary_r2_l, collaborative_r2_l];

      const leadership_most_score_label = Math.max(...leadership_mostValues);
      const leadership_second_most_score_label = Math.max(...leadership_secondMostValues);
      const leadership_least_score_label = Math.max(...leadership_leastValues);
      const leadership_second_least_score_label = Math.max(...leadership_secondLeastValues);

      const getLeadershipLabel = (values, maxValue) => leadership_labels_arr[values.indexOf(maxValue)];

      const leadership_most_label = getLeadershipLabel(leadership_mostValues, leadership_most_score_label);
      const leadership_second_most_label = getLeadershipLabel(leadership_secondMostValues, leadership_second_most_score_label);
      const leadership_least_label = getLeadershipLabel(leadership_leastValues, leadership_least_score_label);
      const leadership_second_least_label = getLeadershipLabel(leadership_secondLeastValues, leadership_second_least_score_label);

      const getLeadershipPercentageOrder = (label) => {
        if (label === leadership_most_label?.toLowerCase()) return leadership_most_per;
        if (label === leadership_second_most_label?.toLowerCase()) return leadership_second_most_per;
        if (label === leadership_least_label?.toLowerCase()) return leadership_least_per;
        if (label === leadership_second_least_label?.toLowerCase()) return leadership_second_least_per;
        return 0;
      };

      // Calculate all values individually
      const heart = getPercentageOrder("heart");
      const strength = getPercentageOrder("strength");
      const soul = getPercentageOrder("soul");
      const mind = getPercentageOrder("mind");

      const collaborative = getLeadershipPercentageOrder("collaborative");
      const performance = getLeadershipPercentageOrder("performance");
      const visionary = getLeadershipPercentageOrder("visionary");
      const strategic = getLeadershipPercentageOrder("strategic");

      const lifeRadarData = [heart, soul, mind, strength];
      const lifeRadarLabels = ['HEART', 'SOUL', 'MIND', 'STRENGTH'];

      const leadershipRadarData = [collaborative, visionary, strategic, performance];
      const leadershipRadarLabels = ['COLLABORATIVE', 'VISIONARY', 'STRATEGIC', 'PERFORMANCE'];

      // Pass these to SpiderChart
      setSnapshotResults(lifeRadarData);
      setStarterLabel(lifeRadarLabels);
      setLeadershipResult(leadershipRadarData);
      setLeadershipLabel(leadershipRadarLabels);
    }
  }, [variablsMapArray]);

  useEffect(() => {
    const calculatedPercentages = {
      twentyLeft: 20, // Replace with dynamic logic
      fourtyLeft: 40, // Replace with dynamic logic
      sixtyLeft: 60, // Replace with dynamic logic
      eightyLeft: 80, // Replace with dynamic logic
      hundreadLeft: 100, // Replace with dynamic logic
      
      twentyRight: 20, // Replace with dynamic logic
      fourtyRight: 40, // Replace with dynamic logic
      sixtyRight: 60, // Replace with dynamic logic
      eightyRight: 80, // Replace with dynamic logic
      hundreadRight: 100, // Replace with dynamic logic
    };
    setPercentages(calculatedPercentages);
  }, [apiData]);

  const styles = {
    page: { paddingTop: "16px", backgroundColor: '#FFFFFF', fontFamily: "Helvetica" },
    header: { display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #00577D', paddingBottom: 5, marginBottom: '2px', marginTop: '-15px', fontFamily: "Helvetica" },
    titleMain: { fontSize: '12px', fontWeight: '700', color: '#76A3BE' },
    title: { fontSize: '11px', fontWeight: '200', color: '#76A3BE' },
    rightSection: { textAlign: 'right' },
    rightText: { fontSize: '8px', fontWeight: '700', color: '#76A3BE' },
    headerText: { fontSize: '14px', fontWeight: '700', color: '#00577D', margin: 0 },
    headerSubText: { fontSize: '11px', fontWeight: '400', color: '#C99212', margin: 0, marginTop: "2px" },
    paragraphContainer: { marginTop: "16px" },
    curiousSection: { color: "#000" },
    curiousSectionHeader: { fontSize: "10px", fontWeight: "700" },
    curiousParagraph: { fontSize: "10px" },
    curiousSectionNote: { fontWeight: "700", color: "#000", fontSize: "10px", margin: "16px 0px",  },
    vsSection: { fontWeight: "700", color: "#00577D", fontSize: "11px", textAlign: "center" },
    paragraph: { fontSize: '10px', fontWeight: '400', color: '#000',  margin: "16px 0px", lineHeight: '14px', letterSpacing: 0 },
    chart: { width: '100%', maxWidth: '510px', height: 'auto', display: 'block', margin: '20px auto' },
    footer: { display: 'flex', justifyContent: 'space-between', borderTop: '1px solid #00577D', paddingTop: 10, marginTop: 20 },
    footerTextHeading: { fontSize: '12px', fontWeight: '700', color: '#76A3BE' },
    footerText: { fontSize: '10px', color: '#76A3BE' },
    chartHead: { display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '80px' },
    chartheading: { fontFamily: 'Helvetica', fontWeight: 700, fontStyle: 'normal', fontSize: '8px', lineHeight: '12px', letterSpacing: '0%', color: '#000000', verticalAlign: 'middle', leadingTrim: 'cap-height' },
    percentages: { display: 'flex', flexDirection: 'row', position: 'relative', paddingBottom: '22px', width:"86%", margin: "0px auto" },
    percentTwentyLeft: { textAlign: 'center', position: 'absolute', left: 'calc(40%)', fontSize: '8px', marginTop: "5px", color: "#000000"  },
    percentFourtyLeft: { textAlign: 'center', position: 'absolute', left: 'calc(31%)', fontSize: '8px', marginTop: "5px", color: "#000000"  },
    percentSixtyLeft: { textAlign: 'center', position: 'absolute', left: 'calc(22.5%)', fontSize: '8px', marginTop: "5px", color: "#000000"  },
    percentEightyLeft: { textAlign: 'center', position: 'absolute', left: 'calc(14.5%)', fontSize: '8px', marginTop: "5px", color: "#000000"  },
    percentHundreadLeft: { textAlign: 'center', position: 'absolute', left: 'calc(4%)', fontSize: '8px', marginTop: "5px", color: "#000000"  },
    
    percentTwentyRight: { textAlign: 'center', position: 'absolute', right: 'calc(38.5%)', fontSize: '8px', marginTop: "5px", color: "#000000"  },
    percentFourtyRight: { textAlign: 'center', position: 'absolute', right: 'calc(29.5%)', fontSize: '8px', marginTop: "5px", color: "#000000"  },
    percentSixtyRight: { textAlign: 'center', position: 'absolute', right: 'calc(21%)', fontSize: '8px', marginTop: "5px", color: "#000000"  },
    percentEightRight: { textAlign: 'center', position: 'absolute', right: 'calc(12.5%)', fontSize: '8px', marginTop: "5px", color: "#000000"  },
    percentHundreadRight: { textAlign: 'center', position: 'absolute', right: 'calc(3%)', fontSize: '8px', marginTop: "5px", color: "#000000" , },
  };

  const pairingMap = {
    Heart: "Collaborative",
    Soul: "Visionary",
    Mind: "Strategic",
    Strength: "Performance",
  };

  const colorMap = {
    Heart: ["#B6111F", "#DB888F"],
    Soul: ["#00577D", "#80ABBE"],
    Strength: ["#C99212", "#E4C988"],
    Mind: ["#426B88", "#A0B5C3"],
  };

  const formatLabel = (label) => {
    return label?.charAt(0).toUpperCase() + label?.slice(1).toLowerCase();
  };

  const pairDatasets = (labels1, percentData1, labels2, percentData2) => {
    return labels1.map((label1, index1) => {
      const cleanLabel1 = formatLabel(label1); // e.g., 'HEART' => 'Heart'
      const pairedLabel = pairingMap[cleanLabel1]; // e.g., Heart => Collaborative

      // Find the index of the paired label in the second dataset
      const index2 = labels2.findIndex(
        (l) => l.toLowerCase() === pairedLabel.toLowerCase()
      );

      return {
        label: cleanLabel1,
        pairedLabel,
        score1: percentData1[index1],
        score2: index2 !== -1 ? percentData2[index2] : null,
        colors: colorMap[cleanLabel1] || [],
      };
    });
  };

  const pairedResults = pairDatasets(starterLabel, snapshotResult, leadershipLabel, leadershipResult);

  // console.log("pairedResults",pairedResults);

  const heart = pairedResults.find(item => item.label === "Heart");
  const soul = pairedResults.find(item => item.label === "Soul");
  const strength = pairedResults.find(item => item.label === "Strength");
  const mind = pairedResults.find(item => item.label === "Mind");


  console.log(pairedResults)
  return (
    <div style={{ backgroundColor: "rgb(255, 255, 255)" }}>
      <HeaderPreview apiData={apiData} />
      <div style={styles.page}>
        <div>
          <div style={styles.container}>
            <h1 style={styles.headerText}>GAP ANALYSIS</h1>
            <h3 style={styles.headerSubText}>Gap Awareness, Alignment, & Integration</h3>
          </div>

          <div style={styles.paragraphContainer}>
            <p style={styles.paragraph}>Comparing your Starter Quadrant and Flow Type™ with your Leadership Style and Leadership Flow™ helps reveal something essential: Are you leading from your design or from adaptation?</p>
            <p style={styles.paragraph}>Sometimes there is alignment. Who you are matches how you lead. Other times there is a gap between your wiring and the style you use.</p>
            <p style={styles.paragraph}>A gap is not automatically a problem. Some gaps are intentional and serve the role, the culture, or the season you are in. These gaps work as long as you know why they exist and how to return to your natural strengths when the pressure shifts. Other gaps are unintentional. They often reflect environments you adapted to, a past season that required survival, or a version of success that never fully fit.</p>
            <p style={{ ...styles.paragraph }}>Most leaders do not drift on purpose. Over time, we adjust to what is expected, rewarded, or simply needed. The cost shows up later as burnout, misalignment, or the feeling that you are wearing someone else’s armor.</p>
          </div>

          <div style={styles.curiousSection}>
            <h3 style={styles.curiousSectionHeader}>Alignment Flow invites you to pause and get curious:</h3>
            <p style={styles.curiousParagraph}>1. Where am I compensating instead of leading from strength?</p>
            <p style={styles.curiousParagraph}>2. What part of me have I sidelined to stay successful?</p>
            <p style={styles.curiousParagraph}>3. Does my leadership still reflect who I am—or just who I’ve needed to be?</p>
          </div>

          <p style={styles.curiousSectionNote}>The more aligned your leadership becomes, the more consistent your communication, expectations, and outcomes become.</p>
          <p style={styles.vsSection}>WHO YOU ARE vs HOW YOU LEAD</p>
          
          {/* <img src={Chart} alt="Gap Analysis Chart" style={styles.chart} /> */}
          <div style={styles.chartHead}>
            <p style={styles.chartheading}>WHO YOU ARE</p>
            <p style={styles.chartheading}>HOW YOU LEAD</p>
          </div>
          {pairedResults.map(({ label, pairedLabel, score1, score2, colors }) => (
            <Likert
              key={label}
              left_labels={[{ label, color: colors[0] }]}
              right_labels={[{ label: pairedLabel, color: colors[1] }]}
              responses={{
                total: 100,
                data: {
                  [label]: score1,
                  [pairedLabel]: score2
                }
              }}
            />
          ))}
          <div style={styles.percentages}>
            <p style={styles.percentTwentyLeft}>{percentages.twentyLeft}%</p>
            <p style={styles.percentFourtyLeft}>{percentages.fourtyLeft}%</p>
            <p style={styles.percentSixtyLeft}>{percentages.sixtyLeft}%</p>
            <p style={styles.percentEightyLeft}>{percentages.eightyLeft}%</p>
            <p style={styles.percentHundreadLeft}>{percentages.hundreadLeft}%</p>

            <p style={styles.percentTwentyRight}>{percentages.twentyRight}%</p>
            <p style={styles.percentFourtyRight}>{percentages.fourtyRight}%</p>
            <p style={styles.percentSixtyRight}>{percentages.sixtyRight}%</p>
            <p style={styles.percentEightRight}>{percentages.eightyRight}%</p>
            <p style={styles.percentHundreadRight}>{percentages.hundreadRight}%</p>
          </div>
        </div>
      </div>
      <FooterPreview pageNumber={pageNumber} />
    </div>
  );
};

export default AlignmentFlowFirst;
